import React from 'react';
import { H2, P, UL, LI, Callout, FeatureLink } from './_shared';

export default {
  slug: 'folders-intro',
  title: 'How folders work',
  category: 'folders',
  summary: 'A folder is the container for everything a deal needs — contracts, addenda, disclosures, signatures, and the audit trail. Modeled on the MRED file system.',
  searchTerms: ['folder', 'transaction', 'mred', 'documents', 'central architecture'],
  related: ['folder-lifecycle', 'sending-for-signature', 'compliance'],
  Body: () => (
    <>
      <P>
        If you're coming from another CRM, folders are probably the biggest
        difference. They're the central organizing unit of RealtyFlows —
        modeled on the MRED transaction-file system, where every deal has
        one place that holds everything signed, filed, or sent.
      </P>

      <H2>What's in a folder</H2>
      <UL>
        <LI><strong>Documents</strong> — purchase agreement, addenda, disclosures, inspection reports, lender pre-approval, etc.</LI>
        <LI><strong>Envelopes</strong> — packets of documents sent for e-signature (DocuSign or Inkless).</LI>
        <LI><strong>Activity</strong> — every action ever taken: who opened, who signed, who edited, when.</LI>
        <LI><strong>Compliance checklist</strong> — required docs for your jurisdiction; auto-updates as you upload.</LI>
        <LI><strong>Health score</strong> — AI signal for "is this folder on track or sliding."</LI>
      </UL>

      <H2>Why one folder per deal</H2>
      <P>
        Audit trail. Every doc lives in one place, every signature event has
        a timestamp, and the whole package is exportable as a single ZIP at
        close — that's what your brokerage's compliance officer wants and
        what state law requires for record retention.
      </P>

      <Callout kind="tip">
        Tip from beta users: name folders by property address + last name,
        e.g. <em>123 Main St — Garcia</em>. Searchable, sortable, unambiguous.
      </Callout>

      <H2>Where to go next</H2>
      <P>
        Learn the <FeatureLink to="/help/folder-lifecycle">folder lifecycle</FeatureLink>{' '}
        (draft → active → in_escrow → closed) and{' '}
        <FeatureLink to="/help/sending-for-signature">how to send envelopes</FeatureLink>.
      </P>
    </>
  ),
};
